// function horizantalScrollVone() {
//   // Find all the sections with the class 'ps-accordian-folder-section'
//   const sections = document.querySelectorAll('.ps-accordian-folder-section');

//   // Iterate over each section to initialize the scroll functionality
//   sections.forEach(section => {
//     const tags = section.querySelectorAll(".folder-tag");
//     const folders = section.querySelectorAll(".folder");

//     if (!tags.length || !folders.length) return; // If no tags or folders are found, skip this section

//     const totalTagsHeight = calcTotalHeights(tags);

//     // Scroll event listener
//     window.addEventListener(
//       "scroll",
//       () => {
//         const lastFolderPosition = folders[folders.length - 1].getBoundingClientRect().y;

//         if (lastFolderPosition <= totalTagsHeight) {
//           tags.forEach((tag, index) => {
//             const reversedIndex = (index + 1) * -1;

//             tag.style.position = "relative";
//             tag.style.top = 0;
//             tag.style.bottom = 0;
//             tag.style.transform = `translate(0, ${calcTotalHeights(folders, reversedIndex)}px)`;
//           });
//         } else {
//           tags.forEach((tag, index) => {
//             const height = tag.getBoundingClientRect().height;
//             const reversedIndex = tags.length - 1 - index;

//             tag.style.position = "";
//             tag.style.top = `${height * index}px`;
//             tag.style.bottom = `${(height - 40) * reversedIndex }px`;
//             tag.style.transform = "";
//           });
//         }
//       },
//       { passive: true }
//     );

//     // Click event listener for folder-tag
//     tags.forEach((tag, index) => {
//       tag.addEventListener("click", (e) => {
//         // Prevent default action (if any)
//         e.preventDefault();

//         // Focus the corresponding folder (based on index)
//         const folderToScrollTo = folders[index];

//         // Optional: Highlight the tag that is clicked (visual feedback)
//         tags.forEach((otherTag) => {
//           otherTag.classList.remove("active");
//         });
//         tag.classList.add("active");

//         // Smooth scroll to the corresponding folder
//         folderToScrollTo.scrollIntoView({
//           behavior: "smooth",
//           block: "start",
//         });

//         // Optionally, you can also focus the folder for better accessibility
//         folderToScrollTo.focus();
//       });
//     });
//   });
// }

// // Calculate total heights
// function calcTotalHeights(arr, stop) {
//   const arrayOfHeights = Array.from(arr)
//     .slice(0, stop || arr.length)
//     .map((item) => item.getBoundingClientRect().height);

//   const sum =
//     arrayOfHeights.length > 0 &&
//     arrayOfHeights.reduce((prev, curr) => prev + curr);
//   return sum;
// }

// // Run the function when the DOM content is loaded
// document.addEventListener("DOMContentLoaded", horizantalScrollVone);
// const temp=document.querySelectorAll(".stack_section  .title a")

document.addEventListener("DOMContentLoaded", function () {
  accordionScroll()
});

gsap.registerPlugin(ScrollTrigger);

// General settings for all components
const time = 0.5; // Duration of animation for each section
const offset = 80; // Offset for vertical positioning

// Loop over each stack wrapper for multiple components
document.querySelectorAll(".stack_wrapper").forEach((stackWrapper) => {

  // Calculate the menubar dynamically for each wrapper based on the number of items in .stack_items li
  const menubar = 60 * stackWrapper.querySelectorAll(".stack_items li").length;

  // Select all stack sections within this wrapper
  const stackSections = stackWrapper.querySelectorAll(".stack_section");

  // Set initial position for each stack section within its wrapper
  gsap.set(stackSections, {
    y: (index) => offset * index + menubar, // Set initial offset dynamically for each section
    transformOrigin: "bottom top",
  });

  // Calculate start and end positions dynamically
  const stackHeight = stackWrapper.offsetHeight;
  const startPos = `top top-=${60 * stackWrapper.querySelectorAll(".stack_items li").length}px`;
  const endPos = `+=${stackHeight}`;

  // Timeline for ScrollTrigger animation
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: stackWrapper,
      start: startPos,
      end: endPos, // Dynamically calculate the end position based on each stack wrapper
      scrub: 0.2, // Smooth scrubbing, adjust as needed
      pin: true, // Pin the wrapper during scroll
      markers: false, // Optional: Set to true for debugging (shows start and end markers)
    },
  });

  // Animate stack sections when they enter the viewport
  tl.from(stackSections, {
    y: (index, target) => target.getBoundingClientRect().height + (offset * index),
    duration: time / 2,
    stagger: time / 1,
    ease: "none", // No easing for smooth scrubbing
  });

});




function accordionScroll() {
  const allScrollComponents = document.querySelectorAll(".ps-accordian-folder-section");
  allScrollComponents.forEach(component => {
    let listItems = component.querySelectorAll(".accordion-trigger");
    listItems.forEach((item, index) => {
      item.setAttribute("role", "button");
      item.setAttribute("aria-expanded", "false");
      item.setAttribute("aria-controls", `accordion${index + 1}`);
      item.setAttribute("aria-label", `Expand section ${index + 1}`);

      // Function to handle scrolling
      function handleScroll(event) {
        event.stopPropagation();
        let targetSection = item.closest(".stack_section");


        if (targetSection) {
          const targetPosition = targetSection.getBoundingClientRect().top + window.scrollY;
          let distanceToScroll;

          if (window.innerWidth < 400) {
            distanceToScroll = targetPosition - 150 - (index * 85);
          }
          else if (window.innerWidth < 576) {
            distanceToScroll = targetPosition - 300 - (index * 80);
          }
          else if (window.innerWidth < 768) {
            distanceToScroll = targetPosition - 200 - (index * 85);
          }
          else if (window.innerWidth < 960) {
            distanceToScroll = targetPosition - 400 - (index * 80);
          }
          else if (window.innerWidth < 1366) {
            distanceToScroll = targetPosition - 200 - (index * 80);
          }
          else {
            distanceToScroll = targetPosition  + (index * 88);
          }
          console.log(distanceToScroll,targetPosition,'kkkkk');
          

          window.scrollTo({
            top: distanceToScroll,
            behavior: "smooth"
          });
          const isExpanded = item.getAttribute("aria-expanded") === "true";
          item.setAttribute("aria-expanded", !isExpanded);
          item.setAttribute("aria-label", !isExpanded ? `Collapse section ${index + 1}` : `Expand section ${index + 1}`);
        }
      }

      // Click event
      item.addEventListener("click", handleScroll);
      // Keyboard event (Enter key)
      item.addEventListener("keydown", function (event) {
        if (event.key === "Enter") {
          handleScroll(event);
        }
      });
    });
  });
};
